import { useRef } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useThemes } from "../Theme/theme";
import { showWarningSnackbar } from "../snackBar/snakbar";

const ImageUploader = ({
    onChange,
    value,
    label = "Upload Signature",
    onRemove = () => { },
    AcceptedFileTypes = "image/*",
    AcceptedMaximumFileSize = 1 // in MB
}) => {
    const inputRef = useRef(null);
    const { theme } = useThemes();

    const handleFileUpload = (file) => {
        if (!file) return;
        if (!file.type.match(AcceptedFileTypes)) {
            showWarningSnackbar(`File type not accepted. Please upload a ${AcceptedFileTypes.replace('/*','')} file.`);            return;
        }
        if (file.size > AcceptedMaximumFileSize * 1024 * 1024) {
            showWarningSnackbar(`File size must be less than ${AcceptedMaximumFileSize}MB`);
            return;
        }
        if (onChange) {
            onChange(file);
        }
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file && file.type.startsWith('image/')) {
            handleFileUpload(file);
        } else {
            showWarningSnackbar('Please drop an image file only');
        }
    };
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        handleFileUpload(file);
    };

    console.log(value)
    return (
        <Box>
            <Box sx={{
                paddingY: "10px",
            }}>
                <Box
                    sx={{
                        position: "relative",
                        height: 140,
                        border: "2px dashed",
                        borderColor: "grey.500",
                        borderRadius: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        cursor: "pointer",
                        overflow: "visible",
                        // background: "inherit",
                        // color: "inherit",
                        background: theme.palette.mode === 'light' || value ? 'white' : '#1e1e1e',
                        color: theme.palette.mode === 'light' || value ? 'black' : 'white',
                        "&:hover": { borderColor: "grey.100" },
                    }}
                    onClick={() => inputRef.current.click()}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={handleDrop}
                >
                    <Typography
                        sx={{
                            position: "absolute",
                            top: -8,
                            left: 10,
                            fontSize: 12,
                            background: "inherit",
                            paddingX: "5px",
                            color: "inherit",
                            "&:hover": { borderColor: "grey.100" },
                        }}
                    >
                        {label}
                    </Typography>

                    {value ? (
                        <img src={value} alt="Uploaded" style={{ maxHeight: "140px", width: "290px", objectFit: "contain" }} />
                    ) : (
                        <Typography fontSize={14} paddingX={5}>
                            Drop image or click to upload
                        </Typography>
                    )}

                    <input
                        key={value}
                        type="file"
                        accept=".jpg,.jpeg,.png"
                        hidden
                        ref={inputRef}
                        onChange={handleFileChange}
                    />
                </Box>
            </Box>
            {value &&
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Button variant="contained" onClick={() => inputRef.current.click()}>REPLACE</Button>
                    <Button variant="outlined" onClick={() => { onChange(null); onRemove() }}>REMOVE</Button>
                </Box>
            }
        </Box>
    );
};

export default ImageUploader;
